import Service from '@ember/service';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import type { Analytics } from 'firebase/analytics';

export default class FirebaseAnalyticsService extends Service {
  private _analytics: Analytics | null = null;

  get analytics(): Analytics | null {
    if (!this._analytics) {
      console.warn('Firebase Analytics not initialized. Analytics tracking will be skipped.');
      return null;
    }
    return this._analytics;
  }

  get isInitialized() {
    return this._analytics !== null;
  }

  initialize() {
    if (this._analytics) {
      console.log('Firebase Analytics already initialized');
      return;
    }

    try {
      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: 'AIzaSyBDdC8nPMl_5Ou96AcSB_Kb8s7NVZSwT6s',
        authDomain: 'tio-employee.firebaseapp.com',
        projectId: 'tio-employee',
        storageBucket: 'tio-employee.firebasestorage.app',
        messagingSenderId: '925629054198',
        appId: '1:925629054198:web:e50d91ad0c333d1a6b00d7',
        measurementId: 'G-YJ1RMSY1WY',
      };

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      this._analytics = getAnalytics(app);

      // Debug mode is automatically enabled for localhost in Firebase Analytics
      if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
        console.log('Firebase Analytics initialized in debug mode for localhost');
      }
    } catch (error) {
      console.error('Failed to initialize Firebase Analytics:', error);
      console.warn('Analytics tracking will be disabled for this session');
      // Don't rethrow - let the app continue without analytics
    }
  }
}
